import { IMAGES } from "./constants";

const SERVICES = [
  {
    tag: "Diagnostics",
    tagColor: "text-[#ff4b2b]",
    title: "Check Engine & Tune-Up",
    desc: "Pinpoint fault codes and live sensor readings right in your driveway.",
    img: IMAGES.engine,
    alt: "Mechanic running a live OBD2 diagnostic scan on a vehicle engine",
    cta: "Request Quote",
  },
  {
    tag: "Starting & Power",
    tagColor: "text-[#00e5ff]",
    title: "Alternator & Starter",
    desc: "OEM replacements for dead starters, bad alternators, and wiring.",
    img: IMAGES.charging,
    alt: "Mechanic replacing an alternator and testing battery charging output",
    cta: "Request Quote",
  },
  {
    tag: "Cooling Systems",
    tagColor: "text-[#ff4b2b]",
    title: "Water Pump & Radiator",
    desc: "Thermostats, coolant flushes, hoses, and complete cooling overhauls.",
    img: IMAGES.cooling,
    alt: "Mechanic replacing a radiator and water pump in a vehicle engine bay",
    cta: "Request Quote",
  },
  {
    tag: "Roadside",
    tagColor: "text-[#00e5ff]",
    title: "Jump Starts & Tires",
    desc: "Fast jump starting, battery replacement, and roadside spare swaps.",
    img: IMAGES.roadside,
    alt: "Technician jump starting a car and swapping a spare tire roadside",
    cta: "Emergency Dispatch",
  },
];

export default function Services() {
  return (
    <section data-testid="services-section" className="py-24 px-6 max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
        <div>
          <p className="font-mono-lbl text-xs uppercase tracking-widest text-[#00e5ff]">
            Full Service Scope
          </p>
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mt-2">
            Mobile Repairs &amp; Roadside
          </h2>
        </div>
        <p className="text-slate-400 text-sm max-w-sm">
          No towing fees. We arrive with factory-grade scanners and heavy-duty field tools.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => (
          <div
            key={s.title}
            data-testid={`service-card-${i + 1}`}
            className="bg-[#101726] border border-white/10 rounded-xl overflow-hidden flex flex-col group hover:border-white/25 transition-colors"
          >
            <div className="h-44 relative overflow-hidden img-drift">
              <img
                src={s.img}
                alt={s.alt}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#101726] via-transparent to-transparent"></div>
            </div>
            <div className="p-5 flex-1 flex flex-col justify-between">
              <div>
                <span className={`font-mono-lbl text-[11px] uppercase ${s.tagColor}`}>{s.tag}</span>
                <h3 className="font-bold text-lg mt-1">{s.title}</h3>
                <p className="text-slate-400 text-xs mt-2">{s.desc}</p>
              </div>
              <a
                href="#quote"
                data-testid={`service-card-${i + 1}-quote-link`}
                className="mt-4 text-xs font-mono-lbl text-cyan-300 group-hover:text-cyan-200 transition-colors"
              >
                {s.cta} &rarr;
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
